export default __webpack_public_path__ + "static/media/food-header.96443aa2.jpg";